import { render, staticRenderFns } from "./position-add.vue?vue&type=template&id=47ad96c4&scoped=true";
import script from "./position-add.vue?vue&type=script&lang=jsx";
export * from "./position-add.vue?vue&type=script&lang=jsx";
import style0 from "./position-add.vue?vue&type=style&index=0&id=47ad96c4&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "47ad96c4", null);
export default component.exports;